import { ComingSoonLanding } from "../../components/ComingSoonLanding.js";
import { MODULES } from "../../lib/modules.js";

const mod = MODULES.find((m) => m.slug === "tasks");

export function TasksLanding() {
  return (
    <ComingSoonLanding
      title={mod?.label ?? "Task-менеджер"}
      description="Простые задачи между сотрудниками: ставить, принимать, закрывать, комментировать. Доска (мои/всё/закрытые), уведомления в Telegram при назначении и изменении статуса."
      visionDocAnchor="/docs/admin-vision/modules.md#5-task-менеджер"
    />
  );
}
